<template lang="html">
    <report-section
        :id="id"
        title="References"
    >
        <ol>
            <li
                id="note-1"
                class="note"
            >
                <div class="note-text">
                    <p>
                        British Columbia Ministry of Forests (1999). BC Watershed Assessment Procedure Guidebook.
                        Retrieved from
                        <a
                            target="_blank"
                            href="http://www.llbc.leg.bc.ca/public/PubDocs/bcdocs/330041/WAPGdbk.pdf"
                        >http://www.llbc.leg.bc.ca/public/PubDocs/bcdocs/330041/WAPGdbk.pdf</a>
                    </p>
                </div>
            </li>

            <li
                id="note-2"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Huo, A., Yang, L., Luo, P., Cheng, Y., Peng, J., & Nover, D. (2021). Influence of landfill
                        and land use scenario on runoff, evapotranspiration, and sediment yield over the Chinese
                        Loess Plateau. Ecological Indicators, 121, 107208.
                    </p>
                </div>
            </li>

            <li
                id="note-3"
                class="note"
            >
                <div class="note-text">
                    <p>
                        White, J.C., M.A. Wulder, T. Hermosilla, N.C. Coops, and G.W. Hobart. (2017). A nationwide
                        annual characterization of 25 years of forest disturbance and recovery for Canada using
                        Landsat time series. Remote Sensing of Environment. 192: 303-321.(<a
                            target="_blank"
                            href="https://doi.org/10.1016/j.rse.2017.03.035"
                        >White et al. 2017</a>). Hermosilla, T., M.A. Wulder, J.C. White, N.C. Coops, G.W. Hobart, L.B.
                        Campbell, (2016). Mass data processing of time series Landsat imagery: pixels to data products
                        for forest monitoring. International Journal of Digital Earth. 9(11), 1035-1054. (<a
                            target="_blank"
                            href="https://doi.org/10.1080/17538947.2016.1187673"
                        >Hermosilla et al. 2016</a>).
                    </p>
                </div>
            </li>

            <li
                id="note-4"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau,
                        S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice,
                        and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover
                        Change.” Science 342 (15 November): 850–53. Data available on-line from: <a
                            target="_blank"
                            href="http://earthenginepartners.appspot.com/science-2013-global-forest"
                        >http://earthenginepartners.appspot.com/science-2013-global-forest</a>
                    </p>
                </div>
            </li>

            <li
                id="note-5"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Government of British Columbia (2020). Freshwater Atlas. Retrieved from <a
                            target="_blank"
                            href="https://catalogue.data.gov.bc.ca/dataset/freshwater-atlas-assessment-watersheds/resource/58737ddf-8687-4831-8336-b3dd464e10b5"
                        >https://catalogue.data.gov.bc.ca/dataset/freshwater-atlas-assessment-watersheds/resource/58737ddf-8687-4831-8336-b3dd464e10b5</a>
                    </p>
                </div>
            </li>

            <li
                id="note-6"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Lewis, D. and Huggard, D.: A model to quantify effects of mountain pine beetle on equivalent
                        clearcut area, Streamline Watershed Manag. Bull., 13, 42–51, 2010.
                    </p>
                </div>
            </li>

            <li
                id="note-7"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Government of British Columbia (2017). Digital Road Atlas. <a
                            target="_blank"
                            href="https://www2.gov.bc.ca/gov/content/data/geographic-data-services/topographic-data/roads"
                        >https://www2.gov.bc.ca/gov/content/data/geographic-data-services/topographic-data/roads</a>
                    </p>
                </div>
            </li>

            <li
                id="note-8"
                class="note"
            >
                <div class="note-text">
                    <p>
                        BC Energy Regulator (2021). Road Rights of Ways. <a
                            target="_blank"
                            href="https://data-bc-er.opendata.arcgis.com/"
                        >https://data-bc-er.opendata.arcgis.com/</a>
                    </p>
                </div>
            </li>

            <li
                id="note-9"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Government of British Columbia (2021). Cumulative Effects Framework. <a
                            target="_blank"
                            href="https://www2.gov.bc.ca/gov/content/environment/natural-resource-stewardship/cumulative-effects-framework"
                        >https://www2.gov.bc.ca/gov/content/environment/natural-resource-stewardship/cumulative-effects-framework</a>
                    </p>
                </div>
            </li>

            <li
                id="note-10"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Government of British Columbia, Fire Perimeters Historical. <a
                            target="_blank"
                            href="https://catalogue.data.gov.bc.ca/dataset/fire-perimeters-historical"
                        >https://catalogue.data.gov.bc.ca/dataset/fire-perimeters-historical</a>
                    </p>
                </div>
            </li>

            <li
                id="note-11"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Government of British Columbia, Pest Infestation Polygons. <a
                            target="_blank"
                            href="https://catalogue.data.gov.bc.ca/dataset/pest-infestation-polygons"
                        >https://catalogue.data.gov.bc.ca/dataset/pest-infestation-polygons</a>
                    </p>
                </div>
            </li>

            <li
                id="note-12"
                class="note"
            >
                <div class="note-text">
                    <p>
                        British Columbia Ministry of Forests (2018). Table Interpolation Program for Stand
                        Yields (TIPSY). Retrieved from <a
                            target="_blank"
                            href="https://www2.gov.bc.ca/gov/content/industry/forestry/managing-our-forest-resources/forest-inventory/growth-and-yield-modelling/table-interpolation-program-for-stand-yields-tipsy"
                        >https://www2.gov.bc.ca/gov/content/industry/forestry/managing-our-forest-resources/forest-inventory/growth-and-yield-modelling/table-interpolation-program-for-stand-yields-tipsy</a>
                    </p>
                </div>
            </li>

            <li
                id="note-13"
                class="note"
            >
                <div class="note-text">
                    <p>
                        Government of British Columbia, TRIM DEM. <a
                            target="_blank"
                            href="https://pub.data.gov.bc.ca/datasets/175624/"
                        >https://pub.data.gov.bc.ca/datasets/175624/</a>
                    </p>
                </div>
            </li>
        </ol>
    </report-section>
</template>

<script>
import sectionMixin from '@foundryspatial/report-section/mixin';

export default {
    note: 'ReferencesSection',
    mixins: [
        sectionMixin,
    ],
};
</script>

<style lang="scss">
#references.report-section {
    font-size: 1rem;
    line-height: 1.25rem;

    *:last-child {
        margin-bottom: 0 !important;
    }

    > ol {
        list-style: none;
        counter-reset: item;
    }

    .note {
        margin: 1rem 0;
        counter-increment: item;
        display: flex;
        flex-direction: row;
        page-break-inside: avoid;

        &::before {
            margin-right: 0.5em;
            color: $primary-light;
            content: counter(item) ". ";
        }

        .note-text {
            flex: 1;
            flex-direction: column;

            ul,
            ol {
                margin-bottom: 1em;
            }

            li {
                list-style-type: circle;
                margin: 0 0 0.5em 2em;
            }

            ul.no-bullets li {
                list-style-type: none;
                margin-left: 0;
                display: flex;
                flex-direction: row;

                .icon {
                    margin-right: 0.4em;
                    margin-top: 0.25em;
                }
            }

            a {
                word-break: break-all;
            }

            p {
                margin-top: 0;

                &.half-margin {
                    margin-bottom: 0.5em;
                }
            }
        }
    }
}
</style>
